<template>
    <Card :padding="0"
        :bordered="false"
        :dis-hover="true">
        <transition name="fade">
            <Row v-if="storeTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="storeTable.searchForm"
                    :table-load-event="getStoreTableRecord"
                    :table-search="storeTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Row :gutter="16">
            <Col span="24">
            <div class="global-tool-bar">
                <div class="left-bar">
                    <span class="title">自用库明细</span>
                </div>
                <div class="right-bar">
                    <Button type="primary"
                        size="small"
                        class="btns"
                        shape="circle"
                        icon="ios-search"
                        @click="storeTable.sarchCardShow = !storeTable.sarchCardShow">搜索</Button>
                    <Button v-if="$checkAccessArray(['B', 'C'])"
                        type="success"
                        size="small"
                        class="btns"
                        shape="circle"
                        @click="onShowEntryModal">入库</Button>
                    <Button v-if="$checkAccessArray(['B', 'C'])"
                        type="warning"
                        size="small"
                        class="btns"
                        shape="circle"
                        @click="onShowConsumeModal">领用</Button>

                    <Button type="error"
                        size="small"
                        class="btns"
                        shape="circle"
                        @click="onShowList">流水</Button>
                    <Button type="info"
                        size='small'
                        class="btns"
                        shape="circle"
                        @click="onExport()">导出</Button>
                </div>
            </div>
            </Col>
        </Row>

        <Row :gutter="16">
            <Col span="24">
            <stand-pagination-table :columns="storeTable.columns"
                :data="storeTable.rows"
                :extHeight="60"
                :loading="storeTable.tableLoading"
                :table-search="storeTable.tableSearch"
                :table-load-event="getStoreTableRecord" />
            </Col>
        </Row>

        <Modal v-model="entryModal.show"
            class-name="vertical-center-modal"
            title="入库"
            width="70">
            <Row :gutter="16">
                <Col span="24">
                <search-card :form="entryProductTable.searchForm"
                    :table-load-event="getEntryProductTableRecord"
                    :table-search="entryProductTable.tableSearch" />
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="entryProductTable.columns"
                    :data="entryProductTable.rows"
                    :extHeight="100"
                    :loading="entryProductTable.tableLoading"
                    :table-search="entryProductTable.tableSearch"
                    :table-load-event="getEntryProductTableRecord" />
                </Col>
            </Row>

            <div slot="footer">
                <Button type="primary"
                    @click="onSubmitEntry">提交入库</Button>
            </div>
        </Modal>

        <Modal v-model="consumeModal.show"
            class-name="vertical-center-modal"
            title="领用"
            width="70">
            <Row :gutter="16">
                <Col span="24">
                <search-card :form="consumeTable.searchForm"
                    :table-load-event="getConsumeTableRecord"
                    :table-search="consumeTable.tableSearch" />
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="consumeTable.columns"
                    :data="consumeTable.rows"
                    :extHeight="100"
                    :loading="consumeTable.tableLoading"
                    :table-search="consumeTable.tableSearch"
                    :table-load-event="getConsumeTableRecord" />
                </Col>
            </Row>

            <div slot="footer">
                <Button type="primary"
                    @click="onSubmitConsume">提交领用</Button>
            </div>
        </Modal>

        <Modal v-model="journalModal.show"
            class-name="vertical-center-modal"
            title="流水"
            width="70"
            :footer-hide="true">
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="journalTable.columns"
                    :data="journalTable.rows"
                    :loading="journalTable.tableLoading"
                    :table-search="journalTable.tableSearch"
                    :table-load-event="getJournalList" />
                </Col>
            </Row>
        </Modal>
    </Card>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import { dateRender } from '@/libs/tableRowTimeRender';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { APPROVAL_YES } from '@/libs/baseModelFormat';
import { singleImageRender } from '@/libs/tableRowImageRender';

import {
    getSelfWarehouseProductStore,
    saveSelfWarehouseConsume,
    saveSelfWarehouseEntry,
    getSelfWarehouseJournalList
} from '@/api/modules/warehouse-management/warehouse';
import { getProductList } from '@/api/modules/product-management/product-management';
import { DOWNLOAD_SERVER } from '@/api/modules/files';

export default {
    name: 'SelfWarehouseStore',
    components: {
        SearchCard,
        StandPaginationTable
    },
    data() {
        return {
            storeTable: {
                columns: [
                    { title: '仓库', key: 'warehouseName', align: 'center', excel: true },
                    { title: '产品编号', key: 'productCode', align: 'center', excel: true },
                    { title: '产品名称', key: 'productName', align: 'center', excel: true },
                    { title: '小类', key: 'subCategoryName', align: 'center', excel: true },
                    { title: '批次号', key: 'selfWarehouseProductStoreBatchCode', align: 'center', excel: true },
                    { title: '仓存量', key: 'selfWarehouseProductStoreAmount', align: 'center', excel: true }
                ],
                rows: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '产品信息', type: 'Input', value: '', name: 'concat(productCode,productName)', sql: 'like' },
                    { label: '批次号', type: 'Input', value: '', name: 'selfWarehouseProductStoreBatchCode', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' }
                ]
            },
            journalModal: {
                show: false
            },
            journalTable: {
                columns: [
                    { title: '仓库', key: 'warehouseName', align: 'center' },
                    { title: '产品编号', key: 'productCode', align: 'center' },
                    { title: '产品名称', key: 'productName', align: 'center' },
                    { title: '小类', key: 'subCategoryName', align: 'center' },
                    { title: '类型', key: 'selfWarehouseStoreJournalType', align: 'center' },
                    { title: '单号', key: 'selfWarehouseStoreJournalBillCode', align: 'center' },
                    { title: '数量', key: 'selfWarehouseStoreJournalAmount', align: 'center' },
                    { title: '登记日期', key: 'selfWarehouseStoreJournalCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.selfWarehouseStoreJournalCreateAt) }
                ],
                rows: [],
                tableLoading: false,
                tableSearch: search.getSearchParams()
            },
            entryModal: {
                show: false
            },
            entryProductTable: {
                columns: [
                    { title: '产品编号', key: 'productCode', align: 'center' },
                    { title: '名称', key: 'productName', align: 'center' },
                    { title: '小类', key: 'subCategoryName', align: 'center' },
                    { title: '单位', key: 'unitName', align: 'center' },
                    { title: '成品图', align: 'center', render: (h, params) => singleImageRender(h, params.row.productFinishImageFile) },
                    {
                        title: '入库数量',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('InputNumber', {
                                    props: {
                                        min: 0,
                                        max: 10000000,
                                        value: params.row.entryAmount
                                    },
                                    on: {
                                        'on-change': val => {
                                            this.entryProductTable.rows[params.index].entryAmount = val;
                                            const find = this.entryProductTable.hasAmount.find(item => {
                                                return item.productUuid === params.row.productUuid;
                                            });
                                            if (find) {
                                                find.entryAmount = val;
                                            }
                                            else {
                                                this.entryProductTable.hasAmount.push({
                                                    productUuid: params.row.productUuid,
                                                    entryAmount: val
                                                });
                                            }
                                        }
                                    }
                                })
                            ]);
                        }
                    }
                ],
                rows: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '产品信息', type: 'Input', value: '', name: 'concat(productCode,productName)', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' }
                ],
                hasAmount: []
            },
            consumeModal: {
                show: false
            },
            consumeTable: {
                columns: [
                    { title: '仓库', key: 'warehouseName', align: 'center' },
                    { title: '产品编号', key: 'productCode', align: 'center' },
                    { title: '产品名称', key: 'productName', align: 'center' },
                    { title: '小类', key: 'subCategoryName', align: 'center' },
                    { title: '批次号', key: 'selfWarehouseProductStoreBatchCode', align: 'center' },
                    { title: '仓存量', key: 'selfWarehouseProductStoreAmount', align: 'center' },
                    {
                        title: '领用数量',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('InputNumber', {
                                    props: {
                                        min: 0,
                                        max: params.row.selfWarehouseProductStoreAmount,
                                        value: params.row.consumeAmount
                                    },
                                    on: {
                                        'on-change': val => {
                                            this.consumeTable.rows[params.index].consumeAmount = val;
                                            const find = this.consumeTable.hasAmount.find(item => {
                                                return item.selfWarehouseProductStoreUuid === params.row.selfWarehouseProductStoreUuid;
                                            });
                                            if (find) {
                                                find.consumeAmount = val;
                                            }
                                            else {
                                                this.consumeTable.hasAmount.push({
                                                    selfWarehouseProductStoreUuid: params.row.selfWarehouseProductStoreUuid,
                                                    consumeAmount: val
                                                });
                                            }
                                        }
                                    }
                                })
                            ]);
                        }
                    }
                ],
                rows: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '产品信息', type: 'Input', value: '', name: 'concat(productCode,productName)', sql: 'like' },
                    { label: '批次号', type: 'Input', value: '', name: 'selfWarehouseProductStoreBatchCode', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' }
                ],
                hasAmount: []
            }
        };
    },
    mounted() {
        this.getStoreTableRecord();
    },
    methods: {
        onShowList() {
            this.journalModal.show = true;
            this.getJournalList();
        },
        getJournalList() {
            this.journalTable.tableLoading = true;
            getSelfWarehouseJournalList(this.journalTable.tableSearch).then(res => {
                this.journalTable.tableLoading = false;
                if (res.code === 0) {
                    this.journalTable.rows = res.data.records;
                    search.globalSetFilterRecordCount(this.journalTable.tableSearch, res.journalTable.filterRecordCount);
                }
            }).catch(() => {
                this.journalTable.tableLoading = false;
            });
        },
        onExport() {
            const searchCondition = search.deepClone(this.storeTable.tableSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.storeTable.columns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.storeTable.tableLoading = true;
            getSelfWarehouseProductStore(searchCondition).then(res => {
                this.storeTable.tableLoading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                    // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                }
            });
        },
        getStoreTableRecord(reset = false) {
            if (reset) {
                search.globalResetSearch(this.storeTable.tableSearch);
            }
            this.storeTable.tableLoading = true;
            getSelfWarehouseProductStore(this.storeTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.storeTable.rows = res.data.records;
                    search.globalSetFilterRecordCount(this.storeTable.tableSearch, res.data.filterRecordCount);
                }
                this.storeTable.tableLoading = false;
            }).catch(() => {
                this.storeTable.tableLoading = false;
            });
        },
        getEntryProductTableRecord(reset = false) {
            if (reset) {
                search.globalResetSearch(this.productTable.tableSearch);
            }

            // 强制设置已审核的过滤
            this.entryProductTable.tableSearch.filters.enable = true;
            const approveFilterQuery = this.entryProductTable.tableSearch.filters.conditions.find(f => f.name === 'productApproval');
            if (approveFilterQuery) {
                approveFilterQuery.value = APPROVAL_YES;
                approveFilterQuery.type = 'eq';
            }
            else {
                this.entryProductTable.tableSearch.filters.conditions.push({
                    name: 'productApproval',
                    type: 'eq',
                    value: APPROVAL_YES
                });
            }

            this.entryProductTable.tableLoading = true;
            this.entryProductTable.tableSearch.limit.conditions.pageLength = 5;
            getProductList(this.entryProductTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.entryProductTable.rows = res.data.records.map(item => {
                        let entryAmount = 0;

                        const find = this.entryProductTable.hasAmount.find(r => {
                            return r.productUuid === item.productUuid;
                        });
                        if (find) {
                            entryAmount = find.entryAmount;
                        }

                        return Object.assign(item, { entryAmount: entryAmount });
                    });
                    search.globalSetFilterRecordCount(this.entryProductTable.tableSearch, res.data.filterRecordCount);
                }

                this.entryProductTable.tableLoading = false;
            });
        },
        onShowEntryModal() {
            this.getEntryProductTableRecord();
            this.entryModal.show = true;
        },
        onSubmitEntry() {
            const hasAmountRows = this.entryProductTable.hasAmount.filter(row => {
                return row.entryAmount > 0;
            });
            if (hasAmountRows.length <= 0) {
                this.$Modal.error({ title: '出错啦', content: '请先填写需要入库的数量' });
                return;
            }

            const submitData = {
                entryProducts: hasAmountRows
            };
            this.entryProductTable.tableLoading = true;
            saveSelfWarehouseEntry(submitData).then(res => {
                this.entryProductTable.tableLoading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '入库成功',
                        content: '',
                        onOk: () => {
                            this.entryProductTable.hasAmount = [];
                            this.entryModal.show = false;
                            this.getStoreTableRecord();
                        }
                    });
                }
            });
        },
        getConsumeTableRecord(reset = false) {
            if (reset) {
                search.globalResetSearch(this.consumeTable.tableSearch);
            }

            this.consumeTable.tableLoading = true;
            this.consumeTable.tableSearch.limit.conditions.pageLength = 5;
            getSelfWarehouseProductStore(this.consumeTable.tableSearch).then(res => {
                this.consumeTable.tableLoading = false;
                if (res.code === 0) {
                    this.consumeTable.rows = res.data.records.map(item => {
                        let consumeAmount = 0;

                        const find = this.consumeTable.hasAmount.find(r => {
                            return r.selfWarehouseProductStoreUuid === item.selfWarehouseProductStoreUuid;
                        });
                        if (find) {
                            consumeAmount = find.consumeAmount;
                        }

                        return Object.assign(item, { consumeAmount: consumeAmount });
                    });
                    search.globalSetFilterRecordCount(this.consumeTable.tableSearch, res.data.filterRecordCount);
                }
            });
        },
        onShowConsumeModal() {
            this.getConsumeTableRecord();
            this.consumeModal.show = true;
        },
        onSubmitConsume() {
            const hasAmountRows = this.consumeTable.hasAmount.filter(row => {
                return row.consumeAmount > 0;
            });
            if (hasAmountRows.length <= 0) {
                this.$Modal.error({ title: '出错啦', content: '请先填写需要领用的数量' });
                return;
            }

            const submitData = {
                consumeProducts: hasAmountRows
            };
            this.consumeTable.tableLoading = true;
            saveSelfWarehouseConsume(submitData).then(res => {
                this.consumeTable.tableLoading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '领用成功',
                        content: '',
                        onOk: () => {
                            this.consumeTable.hasAmount = [];
                            this.consumeModal.show = false;
                            this.getStoreTableRecord();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
